<template>
    <section v-if="(width > 1024)" class="big-sec">
        <div v-if="width > 1024" class="home-page-bg">
            <img src="../assets/images/section-bg-1.png" alt="" />
        </div>
        <div class="big-container">
            <div class="both-img">
                <img src="../assets/images/mobile-with-bg.png" class="big-pic" alt="" />
                <img src="../assets/images/motion-1.gif" class="motion" alt="" />
            </div>
            <div class="text-box">
                <div class="box-content">
                    <h1>
                        آن کلیک <br />
                        سالها تجربه در تبلیغات آنلاین
                    </h1>
                    <p>
                        آن کلیک، اینجاست تا کسب و کار شما را به میلیون ها کاربر در فیلو، یکی
                        از پر بازدیدترین پلتفرم های ویدیویی کشور معرفی کند. شما می توانید با
                        ثبت کمپین های تبلیغاتی هدفمند و خلاقانه، برند خود را برجسته و
                        فروشتان را افزایش دهید.
                    </p>
                     <a :href="isLoggedIn ? campaignPath : loginPath" class="btn btn--primary home-sec1-btn">
                        <span> شروع تبلیغ </span>
                        <img src="../assets/images/login-bold-duotone.svg" class="icon" />
                     </a>
                </div>
            </div>
        </div>
    </section>
    <section v-else class="small-sec">
        <div class="small-container">
            <img class="small-pic" src="../assets/images/mobile.png" alt="">
            <div class="text-content">
                <h1>
                    آن کلیک <br />
                    سالها تجربه در تبلیغات آنلاین
                </h1>
                <p>
                    آن کلیک، اینجاست تا کسب و کار شما را به میلیون ها کاربر در فیلو، یکی
                    از پر بازدیدترین پلتفرم های ویدیویی کشور معرفی کند. شما می توانید با
                    ثبت کمپین های تبلیغاتی هدفمند و خلاقانه، برند خود را برجسته و
                    فروشتان را افزایش دهید.
                </p>
            </div>
            <a :href="isLoggedIn ? campaignPath : loginPath" class="btn btn--primary home-sec1-btn">
                 <span> شروع تبلیغ </span>
                 <img src="../assets/images/login-bold-duotone.svg" class="icon" />
            </a>
        </div>
    </section>
</template>

<script>
import { ref,inject } from 'vue';
export default {
    name: "HomeSection1",

    setup() {
        const isLoggedIn = inject('isLoggedIn', ref(false));
        const campaignPath = inject('campaignPath');
        const loginPath = inject('loginPath');
        const width = inject('viewportWidth');

        return {width, isLoggedIn, campaignPath, loginPath};
    },
};
</script>

<style scoped>
.home-page-bg {
  width: calc(100% - 339px);
  height: 800px;
}

.home-page-bg img {
  width: 100%;
  height: 100%;
}

h1 {
    font-family: IRANYekan-Bold;
}

.big-sec {
    top: -118px;
    position: relative;
}

.big-sec,
.big-pic {
    width: 100%;
}

.big-pic,
.motion {
    position: absolute;
}

.big-container {
    margin-top: 3%;
    margin-inline: 12.58%;
    width: calc(100% - 25.16%);
    grid-template-columns: 33.83% 51.428%;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 118px;
    right: 0;
    left: 0;
}

.big-container,
.small-container {
    display: grid;
}

.both-img {
    position: relative;
    aspect-ratio: 486 / 604;
    max-height: 604px;
}

.both-img,
.small-pic {
    align-self: center;
}

.big-pic {
    aspect-ratio: 486 / 417;
    object-fit: contain;
}

.big-pic,
.motion {
    overflow: hidden;
}

.motion {
    width: 51.45%;
    z-index: 1;
    top: 58.61%;
    left: -25.52%;
    box-shadow: 0 2px 10px var(--shadow-light);
}

.motion,
.text-box,
.small-sec {
    border-radius: 20px;
}

.text-box {
    padding: 8.8% 12.24%;
    box-shadow: 0px 0px 10px var(--shadow-light);
}

.text-box,
.small-sec {
    background-color: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
}

.box-content {
    display: flex;
    flex-direction: column;
    gap: 32px;
    align-items: flex-start;
}

.box-content h1 {
    font-size: 30px;
    line-height: 42px;
}

.box-content p {
    line-height: 28px;
}

.box-content p,
.text-content p {
    text-align: justify;
}

.home-sec1-btn {
    height: fit-content;
}

.small-sec {
    margin-top: 27px;
    margin-inline: 5.556%;
    padding: 40px 4.75%;
    box-shadow: 0 0 2px var(--shadow-light);
}

.small-container {
    justify-items: center;
    row-gap: 12px;
    grid-template-columns: 40% 60%;
}

.small-pic {
    width: 80%;
    aspect-ratio: 260 / 257;
    min-width: 166px;
    grid-row: 1 / 3;
    justify-self: start;
}

.text-content h1 {
    font-size: 24px;
    line-height: 34px;
    margin-bottom: 12px;
}

.text-content p {
    line-height: 26px;
}

@media screen and (min-width: 1921px) {
    .home-page-bg {
        width: calc(100% - ((100% - 1614px) / 2 + 186px));
    }

    .big-container {
        width: 1437px;
        margin-inline: auto;
        margin-top: 2%;
    }
}

@media screen and (max-width: 1600px) {
  .home-page-bg {
    height: 700px;
  }
}

@media screen and (max-width: 1440px) {
    .home-page-bg {
        width: calc(100% - 258px);
        height: 660px;
    }

    .box-content {
        gap: 20px;
    }
}

@media screen and (max-width: 1230px) {
    .big-container {
        margin-inline: 11.08%;
        width: calc(100% - 22.16%);
    }
}

@media screen and (max-width: 1024px) {
    .home-sec1-btn {
        box-shadow: 0 0 5px var(--shadow-pink);
        justify-self: start;
        grid-column: 2;
    }

}

@media screen and (max-width: 768px) {
    .small-sec {
        margin-top: 26px;
        padding: 18px 3.75% 21px;
    }

    .small-container {
        grid-template-columns: 100%;
    }

    .small-pic {
        width: 180px;
        height: 178px;
        grid-row: 1;
        justify-self: center;
    }

    .home-sec1-btn {
        grid-column: 1;
        justify-self: center;
    }
}

@media screen and (max-width: 375px) {
    .text-content h1 {
        font-size: 20px;
    }

    .text-content p {
        font-size: 16px;
    }
}
</style>